<div (click)="focusInput()" class="chip-tokens-field">
    @for (chip of value; track chip; let i = $index) {
    <span class="chip-tokens-chip">
        <span class="chip-tokens-chip-label">{{ chip }}</span>
        <button
            (click)="$event.stopPropagation(); removeAt(i)"
            [attr.aria-label]="'Remove ' + chip"
            class="chip-tokens-chip-remove"
            type="button"
        >
            <svg aria-hidden="true" height="10" viewBox="0 0 24 24" width="10">
                <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-linecap="round" stroke-width="2.5" />
            </svg>
        </button>
    </span>
    }
    <input
        #chipInput
        (blur)="onBlur()"
        (focus)="onFocus()"
        (keydown)="onKeydown($event)"
        (paste)="onPaste($event)"
        [attr.id]="inputId || null"
        [disabled]="isDisabled"
        [placeholder]="value.length === 0 ? placeholder : ''"
        class="chip-tokens-input"
        type="text"
    />
</div>
